import React from 'react';
import { useTranslation } from 'react-i18next';

const SkipToMain: React.FC = () => {
  const { t } = useTranslation();

  return (
    <a
      href="#main-content"
      className="skip-to-main"
    >
      {t('a11y.skipToMain')}
    </a>
  );
};

export default SkipToMain;
